const container = document.querySelector('.category-select__content');

let clonedButtons = null;
let clonedSelect = null;

// Function to add elements based on viewport size
function addElementBasedOnViewport() {
  const viewportWidth = window.innerWidth;
  const buttons = document.querySelector('.category-select__list');
  const select = document.querySelector('.category-select__dropdown-wrapper');

  // Add the appropriate element based on viewport size
  if (viewportWidth >= 1130) {
    if (buttons) {
      clonedButtons = buttons.cloneNode(true);
      buttons.parentNode.removeChild(buttons);
    }
    if (select) {
      clonedSelect = select.cloneNode(true);
      select.parentNode.removeChild(select);
    }

    // Add the cloned first element
    if (clonedButtons) {
      container.appendChild(clonedButtons);
      categoriesButtonInit();
    }
  } else {
    if (buttons) {
      clonedButtons = buttons.cloneNode(true);
      buttons.parentNode.removeChild(buttons);
    }
    if (select) {
      clonedSelect = select.cloneNode(true);
      select.parentNode.removeChild(select);
    }

    // Add the cloned first element
    if (clonedSelect) {
      container.appendChild(clonedSelect);
      filterCategoriesBySelect();
    }
  }
}

// Display all items
const viewAllCategories = () => {
  const wrappers = document.querySelectorAll('.post-list__wrapper');
  wrappers.forEach((wrapper) => {
    wrapper.classList.remove('hidden');
  });
};

const viewSelectedCategory = (selected) => {
  // Get the corresponding category class based on the button id
  const category = `.${selected}`;

  // Hide all post-list__wrapper elements
  const wrappers = document.querySelectorAll('.post-list__wrapper');
  wrappers.forEach((wrapper) => {
    wrapper.classList.add('hidden');
  });

  // Show the selected category post-list__wrapper
  const selectedWrapper = document.querySelector(
    `.post-list__wrapper${category}`
  );
  if (selectedWrapper) {
    selectedWrapper.classList.remove('hidden');
  }
};

const categoriesButtonInit = () => {
  // Get all the .category-selector elements
  const buttons = document.querySelectorAll('.category-selector');

  // Add click event listener to each button
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      // Remove 'selected' class from all buttons
      buttons.forEach((btn) => {
        btn.classList.remove('selected');
      });

      // Show all post-list__wrapper elements when 'View All' is clicked
      if (button.id === 'view-all') {
        // Display all items
        viewAllCategories();
      } else {
        viewSelectedCategory(button.id);
      }
      // Add 'selected' class to the clicked button
      button.classList.add('selected');
    });
  });
};

const filterCategoriesBySelect = () => {
  // Assuming you have imported the necessary modules

  var selectElement = document.getElementById('category-select');

  selectElement.addEventListener('change', function () {
    var selectedOption = selectElement.value;

    // Perform actions or filtering based on the selected option
    if (selectedOption === 'viewAll') {
      // Display all items
      viewAllCategories();
    } else {
      // Filter items based on the selected category
      viewSelectedCategory(selectedOption);
    }
  });
};

// Initial check when the page loads
addElementBasedOnViewport();

// Update elements on window resize
window.addEventListener('resize', addElementBasedOnViewport);
